import * as yup from 'yup'

import { CancelRequestType, FormFields, RefundRequestType } from './types'

export const getValidationSchema = (customMinAmount = 100, customMaxAmount = 10000) =>
  yup.object().shape({
    [FormFields.cancelRequestType]: yup
      .string()
      .oneOf([CancelRequestType.Schedule, CancelRequestType.Now])
      .required(),
    [FormFields.refundRequestType]: yup
      .string()
      .oneOf([
        RefundRequestType.none,
        RefundRequestType.full,
        RefundRequestType.prorated,
        RefundRequestType.custom,
      ])
      .required(),
    [FormFields.customAmount]: yup.number().when(FormFields.refundRequestType, {
      is: RefundRequestType.custom,
      then: yup
        .number()
        .min(customMinAmount / 100)
        .max(customMaxAmount / 100)
        .required(),
    }),
  })
